import type {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";
import {axios} from "@/src/modules/core/lib";

import type {PropertyAmenity} from "../types";

export function createPropertyAmenityApi(facilityPath: string, facilitiesListPath: string) {
  class PropertyAmenityApi extends ResourceApi<PropertyAmenity> {
    constructor() {
      super(facilityPath, {listPath: facilitiesListPath});
    }

    delete(id: number): Promise<AxiosResponse<void>> {
      return axios({
        url: `${facilityPath}/${id}`,
        method: "delete",
        data: {property_amenity_id: id},
      });
    }
  }

  return new PropertyAmenityApi();
}
